import './VendorForm.css';
import React, { useEffect, useState } from "react";
import { Col, InputGroup, Form, Row } from "react-bootstrap";
import * as apicall from '../../components/Apicall';
import { Formik } from "formik";
import Loader from '../../components/Loader';
import Skeleton from 'react-loading-skeleton';

const VendorForm3 = ({ vendorData, vendor_id, prev, onSubmit }) => {
  console.log(vendorData, vendor_id, prev, onSubmit, " vendorData, vendor_id, prev, onSubmit ")
  const currency = String(vendorData?.contactNumber || "").startsWith("91") ? "₹" : "د.إ";
  const [loading, setLoading] = useState(false);
  const [skeletonLoading, setSkeletonLoading] = useState(false);
  const [pricingFormdata, setPricingFormdata] = useState([]);
  const [setpricing, setPricing] = useState([]);
  const [priceError, setPriceError] = useState("");
  const [selectedMonth, setSelectedMonth] = useState(0);
  const [months, setMonths] = useState([
    { id: 1, name: "January" },
    { id: 2, name: "February" },
    { id: 3, name: "March" },
    { id: 4, name: "April" },
    { id: 5, name: "May" },
    { id: 6, name: "June" },
    { id: 7, name: "July" },
    { id: 8, name: "August" },
    { id: 9, name: "September" },
    { id: 10, name: "October" },
    { id: 11, name: "November" },
    { id: 12, name: "December" }
  ])

  // console.log(setpricing, "pricingFormdata")
  useEffect(() => {
    if (vendor_id == 0 || vendor_id == "0") {
      fetchDetails(0);
    }
  }, []);


  const fetchDetails = async (month) => {
    console.log(month, "month")
    try {
      setSelectedMonth(month);
      setPricing([]);

      console.log(vendorData, "vendorData")
      if (month === 0 || month !== "") {
        var offering_Ids = [];
        var typeIds = [];
        var locationIds = [];
        // Safely extract IDs
         for (const id of vendorData?.serviceOffering) {
          if (id?.id) offering_Ids.push(id.id);
        }
        for (const serviceType of vendorData?.selectedNewServiceType) {
          // console.log(vendorData?.selectedNewServiceType, "vendorData?.selectedNewServiceType")
          if (serviceType?.id) typeIds.push(serviceType.id);
        }

        for (const serviceLocation of vendorData?.selectlocation) {
          // console.log(vendorData?.selectedNewServiceType, "vendorData?.selectedNewServiceType")
          if (serviceLocation?.id) locationIds.push(serviceLocation.id);
        }
        const offerings = offering_Ids.join(",");

        // const offering_ids = offeringIds.join(",");
        const type_ids = typeIds.join(",");
        const location_ids = locationIds.join(",");

        const data = {
          vendor_id: vendor_id,
          month: month,
          offerings: offerings,
          TypeIds: type_ids,
          LocationIds: location_ids
        };

        console.log("data", data);

        setSkeletonLoading(true);

        const res = await apicall.post(data, "vendorEdit_ServiceType_Price");
        console.log(res, "res")
        setPricing(res.data)

        // console.log("res", res?.data);

        // Set pricing data and ensure fixed_cost is initialized
        // const updatedPricing = res.data.map(offering => {
        //   const updatedServiceType = {};
        //   for (const [serviceTypeName, tiers] of Object.entries(offering.ServiceType)) {
        //     updatedServiceType[serviceTypeName] = tiers.map(tier => ({
        //       ...tier,
        //       // Ensure fixed_cost is set correctly
        //       fixed_cost: tier.fixed_cost, // Default to 0 if undefined
        //     }));
        //   }
        //   return {
        //     ...offering,
        //     ServiceType: updatedServiceType,
        //   };
        // });

        // setPricing(updatedPricing);
      }
    } catch (error) {
      console.error("Failed to fetch services:", error.message);
    } finally {
      setSkeletonLoading(false);
    }
  };

  const change_price = (offeringIndex, locationId, tier, key, value) => {
    console.log("locationName", locationId);
  
    setPricing((prevOfferings) => {
      return prevOfferings.map((offering, oIndex) => {
        if (oIndex !== offeringIndex) return offering;
  
        return {
          ...offering,
          ServiceType: Object.entries(offering.ServiceType).reduce((acc, [serviceType, tiers]) => {
            acc[serviceType] = tiers.map((service) =>
              service.location === Number(locationId) && service.service_tier_name === tier
                ? { ...service, [key]: value === "" ? "" : Number(value) } // blank while typing, number otherwise
                : service
            );
            return acc;
          }, {}),
        };
      });
    });
  
    // Force re-render if needed
    // setTimeout(() => setPricing([...setpricing]), 0);
  };
  


  const submit = async () => {
    setPriceError("");
    setLoading(true);

    let is_price_valid = true;
    let service_offerings_price = [];

    // Validate price values in `setpricing`
    for (const offering of setpricing) {
      for (const [serviceType, tiers] of Object.entries(offering.ServiceType)) {
        for (const tier of tiers) {
          if (tier.fixed_cost <= 0) {
            is_price_valid = false;
          }
        }
      }
    }

    if (!is_price_valid) {
      setPriceError("Price value must be greater than 0");
      setLoading(false);
      return;
    }

    // Prepare data to submit
    for (const offering of setpricing) {
      for (const [serviceType, tiers] of Object.entries(offering.ServiceType)) {
        for (const tier of tiers) {
          let obj = {
            price_id: tier.pricing_id,
            service_offering_id: offering.id,
            service_tier: tier.service_tier,  // Now considering all tiers
            fixed_price: tier.fixed_cost, // Collect fixed_cost
            unit_price: 0,
            service_type_id: tier.service_type_id,
            service_tier_name: tier.service_tier_name,
            location: tier.location
          };

          service_offerings_price.push(obj);
        }
      }
    }
    const finaldata = {
      month: selectedMonth,
      service_offerings_price: service_offerings_price,
    };

    // console.log("Final Data:", finaldata);

    // Simulate a delay for loading
    setTimeout(() => {
      setLoading(false);
    }, 5000); // Reduced timeout for better UX

    onSubmit(finaldata);
  };


  return (
    <div className="container vp">
      <h3 className='heading'>Fill Offering Prices</h3>

      <p className='label'>Enter the prices for every offering across all months.</p>
      {vendor_id != 0 &&
        <div className="mb-3 d-flex flex-row">
          <label htmlFor="membershipType" className="label mt-2 me-2">Select Month:</label>
          <select
            id="months"
            name="months"
            value={selectedMonth}
            onChange={(e) => { fetchDetails(e.target.value) }}
            className="form-select" style={{ width: '190px' }}
          >
            <option value="">Select a month</option>
            {months.map(plan => (
              <option key={plan.id} value={plan.id}>{plan.name}</option>
            ))}
          </select>
        </div>
      }
      {skeletonLoading ? (
        <Skeleton count={4} height={100} />
      ) : (
        <Formik
          initialValues={{}}
          onSubmit={(values) => {
            submit();
          }}
        >
          {({ handleSubmit }) => (
            <Form noValidate onSubmit={handleSubmit}>
              {setpricing.length > 0 && (
                <div>
                  {setpricing.map((offering, offeringIndex) => (
                    <div key={offeringIndex} className="vp-offering">
                      <div className="vp-offering-head">{offering.name}</div>
                      <div className="vp-scroll">
                      {Object.keys(offering.ServiceType).map((serviceTypeName, serviceIndex) => {
                        const locations = offering.ServiceType[serviceTypeName].reduce((acc, service) => {
                    if (!acc[service.locname]) {
                      acc[service.locname] = { services: [], locationId: service.location };
                    }
                    acc[service.locname].services.push(service);
                    return acc;
                  }, {});
                        return (
                          <div key={serviceIndex} className="vp-type">
                            <div className="vp-type-name">{serviceTypeName}</div>
                            <table className="vp-table">
                    <thead>
                      <tr><th>Location</th><th>Primary cost</th><th>Standard cost</th></tr>
                    </thead>
                    <tbody>
                      {Object.entries(locations).map(([locName, { services, locationId }], locIndex) => {
                        const primary = services.find((s) => s.service_tier_name === "Primary") || {};
                        const standard = services.find((s) => s.service_tier_name === "Standard") || {};
                        return (
                          <tr key={locIndex}>
                            <td className="vp-loc">{locName}</td>
                        <td>
                          <InputGroup className="vp-input">
                            <InputGroup.Text>{currency}</InputGroup.Text>
                            <Form.Control
                              type="number"
                              min="0"
                              placeholder="0"
                              value={primary.fixed_cost ?? ""}
                              onChange={(e) => {
                                change_price(offeringIndex, locationId, "Primary", "fixed_cost", e.target.value);
                              }}
                            />
                          </InputGroup>
                        </td>
                        <td>
                          <InputGroup className="vp-input">
                            <InputGroup.Text>{currency}</InputGroup.Text>
                            <Form.Control
                              type="number"
                              min="0"
                              placeholder="0"
                              value={standard.fixed_cost ?? ""}
                              onChange={(e) => {
                                change_price(offeringIndex, locationId, "Standard", "fixed_cost", e.target.value);
                              }}
                            />
                          </InputGroup>
                        </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                          </div>
                        );
                      })}
                      </div>
                    </div>
                  ))}
                </div>
              )}

              {/* Buttons */}
              <div className="d-flex justify-content-center text-danger mt-2">{priceError}</div>
              <div className="vf-actions d-flex justify-content-center mt-4 mb-2">
                <button
                  type="button"
                  className="btn Button primaryColorText btn-outline-secondary me-2 no-hover-effect"
                  onClick={prev}
                >
                  Back
                </button>
                {setpricing.length > 0 && (
                  <button
                    type="submit"
                    className="btn Button primaryBackground text-white position-relative d-flex justify-content-center align-items-center"
                  >
                    {loading ? <Loader style={{ height: "30", width: "40" }} /> : "Save"}
                  </button>
                )}
              </div>
            </Form>
          )}
        </Formik>


      )
      }
    </div >
  );
};

export default VendorForm3;
